import { forwardRef, InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

type SelectProps = {
  options: {
    label: string;
    value: string | number | undefined;
    disabled?: boolean;
    selected?: boolean;
  }[];
} & InputHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, className, onChange, ...props }: SelectProps,
  ref
) {
  const selectedOption = options.find((option) => option.selected);
  const dynamicValueProp = {
    [onChange ? 'value' : 'defaultValue']: selectedOption?.value,
  };
  return (
    <select
      ref={ref}
      className={twMerge(
        'select select-bordered w-full max-w-xs rounded-full bg-base-300',
        className
      )}
      {...dynamicValueProp}
      onChange={onChange}
      {...props}
    >
      {options.map(({ value, label, disabled }) => (
        <option key={value} value={value} disabled={disabled}>
          {label}
        </option>
      ))}
    </select>
  );
});
